/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { format } from '/client/src/utils/amountTransformation';
import { currency } from '/client/src/constants/';

export const receiptsColumns = (): [] => {
  return [
    {
      name: 'Guests',
      cell: (row: {}): React.Element => {
        return (
          <span>{row.customer_first_name} {row.customer_last_name}</span>
        );
      }
    },
    {
      name: 'Total Paid',
      cell: (row: {}): React.Element => {
        return (
          <span>{format(currency[_.get(row, 'currency', 'USD')], +row.amount, true)}</span>
        );
      }
    }
  ];
};

export const ticketColumns = (): [] => {
  return [
    {
      name: 'Guests',
      cell: (row: {}): React.Element => {
        return (
          <span>{row.first_name} {row.last_name}</span>
        );
      }
    },
    {
      selector: 'ticket.name',
      name: 'Ticket Type'
    },
    {
      name: 'Net Paymnet',
      cell: (row: {}): React.Element => {
        return (
          <span>{format(currency[_.get(row, 'currency', 'USD')], +row.ticket.amount, true)}</span>
        );
      }
    }
  ];
};
